import Markdown from "components/markdown/markdown";
import styles from "./discussionList.module.css";

type CustomMarkdownProps = {
  children: React.ReactNode;
  options: {};
};

export const DiscussionList = ({ text }: { text: string }) => {
  const CustomList = ({ children, ...props }: CustomMarkdownProps) => (
    <div className="flex">
      <li {...props}>{children}</li>
    </div>
  );

  return (
    <div className={styles["ordered-list"]}>
      <Markdown
        className={`text-[16px] leading-[130%] text-mono-70`}
        text={text}
        options={{
          forceBlock: true,
          overrides: {
            li: {
              component: CustomList,
              props: {
                className: `${styles["list-item"]}`,
              },
            },
          },
        }}
      />
    </div>
  );
};
